export default __webpack_public_path__ + "static/media/Patterns.fcb85575.svg";